import React from 'react';
import styled from 'styled-components';

const ConnectDiv = styled.nav`
  background-color: #389e0d;
  display: flex;
  justify-content: center;
  height: 30px;
  /* width:100%; */
  position: static;
  top:0;
  right:0;
  z-index:1;
  padding: 10px 10px;
`
const ConnectCaption= styled.h3`
  text-align: center;
  color: white;
  font-size: 12px;
  font-weight:normal;

`
const WalletConnect = () => {
  return(
    <ConnectDiv>
      <ConnectCaption>Wallet Connected</ConnectCaption>
    </ConnectDiv>
  );
};

export default WalletConnect;